import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faCloud, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { PlanAction } from '../../paid-subscription/enums/planAction.enum';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import Helper from 'src/app/Util/helper';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { API_ERRORS } from 'src/app/Util/constants';
import { SubscriptionPlan } from 'src/app/interfaces/plan.interface';
import { SubscriptionStatusType } from 'src/app/types/subscription.type';
import { SubscriptionStatus } from 'src/app/enums/subscription.enum';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { ErrorMessages } from 'src/app/Util/keys';
import { Edition } from 'src/app/enums/plan.enum';
import { CloudVendorType } from 'src/app/paid-subscription/types/cloud-vendor.type';
import { SubscriptionPlansRequest } from 'src/app/interfaces/services/subscription.interface';

@Component({
  selector: 'app-available-plans',
  templateUrl: './available-plans.component.html',
  styleUrls: ['./available-plans.component.sass']
})

export class AvailablePlansComponent implements OnInit, OnDestroy {

  faCloud: IconDefinition;
  wizardTabs: string[];
  tabIndex: number = 0;
  title: string = "Choose a Plan";

  subscriptionId: string | undefined;
  period: string | null = null;
  subscriptionPlans: SubscriptionPlan[] = [];
  selectedPlan: SubscriptionPlan | undefined = undefined;
  availablePlansCount: number = 0;

  cloudVendor: CloudVendorType | undefined = undefined;
  IsConfirmationTab: boolean = false;

  isLoadingPlans: boolean = true;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private cloudSubscriptionService: CloudSubscriptionService,
    private router: Router,
    private notificationService: CloudNotificationService,
    private localStorage: LocalStorageService,
  ) { }

  PlanAction = PlanAction;

  ngOnInit(): void {

    this.initializeIcons();

    this.getSubscriptionIdFromQueryParams();

    this.setPeriodData();

    if (!this.subscriptionId) {
      this.navigateToSubscriptionDashboard();
    }

    this.getSubscriptionPlans(this.subscriptionId);

    this.setWizardTabs();
  }

  initializeIcons() {
    this.faCloud = faCloud;
  }

  setPeriodData() {
  if(this.period?.toLowerCase() == 'monthly'){
    this.period = 'monthly'
  }else if(this.period?.toLowerCase() == 'one-year'||this.period?.toLowerCase() == 'oneyear'){
    this.period = 'one_year'
  }
}

  setWizardTabs() {
    if (this.period.toLowerCase() != "monthly") {
      console.log("setWizardTabs - Select Plan and Confirmation");
      this.wizardTabs = [PlanAction.SelectPlan, PlanAction.Confirmation]
    } else {
      console.log("not Monthly");
      this.wizardTabs = [PlanAction.Confirmation]
    }

  }

  onPlanSelection(plan: SubscriptionPlan) {
    this.selectedPlan = plan;
  }

  onWizardTabChange(tabIndex: number) {
    this.tabIndex = tabIndex;
  }

  setTitle(title: string) {
    this.title = title;
  }

  private getSubscriptionIdFromQueryParams(): void {
    this.route.queryParams.subscribe(params => {
      this.subscriptionId = params?.subscriptionId || null;
      this.period = params?.period || null;
    })
  }
  private setMonthlyPlan() {
    if (this.period.toLowerCase() == 'monthly') {
      this.onPlanSelection(this.subscriptionPlans[0]);
    }
  }

  private getSubscriptionPlans(subscriptionId: string): void {

    this.isLoadingPlans = true;
    const plansRequest: SubscriptionPlansRequest = {
      subscriptionId: subscriptionId,
      period: this.period || ''
    }
    this.cloudSubscriptionService.getSubscriptionPlans(plansRequest).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (subscriptionPlansResponse) => {
        this.cloudVendor = subscriptionPlansResponse.cloudVendor;
        // this.handleSubscriptionStatus(subscriptionPlansResponse.subscriptionStatus);
        this.subscriptionPlans = subscriptionPlansResponse.plans;
        this.availablePlansCount = this.subscriptionPlans.length;
        console.log(this.availablePlansCount);
        if (this.period.toLowerCase() == "monthly") {
          this.selectedPlan = this.subscriptionPlans[0];
        }
        this.isLoadingPlans = false;
        this.sortPlansAsec()
      },

      error: (err: string) => {
        this.isLoadingPlans = false;
        const errMsg = Helper.resolveErrorMessage(err)
        this.notificationService.createorUpdateToastNotification(API_ERRORS.get_subscription_plan.title, errMsg, CloudNotificationStyle.danger);
        if (errMsg.includes(ErrorMessages.SUBSCRIPTION_NOT_FOUND)) {
          this.navigateToSubscriptionDashboard()
        }
      }

    })
  }

  private sortPlansAsec() {
    if (this.subscriptionPlans[0]?.edition == Edition?.Professional) {
      [this.subscriptionPlans[0], this.subscriptionPlans[1]] = [this.subscriptionPlans[1], this.subscriptionPlans[0]]
    }
  }

  private handleSubscriptionStatus(status: SubscriptionStatusType): void {
    switch (status) {
      case SubscriptionStatus.AwaitingActivation:
      case SubscriptionStatus.Active:
      case SubscriptionStatus.Expired:
      case SubscriptionStatus.Unsubscribed:
      case SubscriptionStatus.UnsubscribePending:
      case SubscriptionStatus.Suspended:
        this.navigateToSubscriptionDashboard();
        break

      case SubscriptionStatus.AwaitingQuotation:
        this.navigateToQuotation();
        break
    }
  }

  private navigateToQuotation(): void {
    this.router.navigate([environment.api.routes.quotation], { queryParams: { subscriptionId: this.subscriptionId } })
  }

  private navigateToSubscriptionDashboard() {
    this.router.navigate([environment.routes.subscription]);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

}



